import styled from 'styled-components'

const BodyWrapper = styled.div`
  display: flex;
  flex: 1;
  width: 100%;
  min-height: calc(100vh - 120px);
`

export default BodyWrapper
